import PropTypes from "prop-types"
import { Fragment } from "react"
import { get, isEmpty, map } from "lodash"
import { List, ListItemButton, ListItemText } from "@mui/material"
import MetricType from "components/metrics-selector/metric-type"
import { MetricItemShape } from "./helpers/prop-types"
import ExpandIcon from "./expandIcon"
import CheckboxElement from "./checkbox"

export default function Metric({
  subcategoryType,
  item,
  toggleSection,
  toggleSelectedMetricColumn,
  disableOptions,
  includeMetricTypes,
  getIsSectionOpen,
}) {
  const subcategoryItemKey = `${subcategoryType}.${item.id}`
  const metricTypeOptions = get(item, "metricTypeOptions", [])
  const useMetricTypes = includeMetricTypes && !isEmpty(metricTypeOptions)
  const isDisabled = !item.selected && !useMetricTypes && disableOptions
  const isSectionOpen = getIsSectionOpen(subcategoryItemKey)

  function handleClick() {
    const handler = useMetricTypes ? toggleSection : toggleSelectedMetricColumn
    handler(subcategoryType, item.id)
  }

  return <Fragment>
    <ListItemButton
      disabled={isDisabled}
      classes={{ root: "list-item" }}
      className="metrics-item"
      key={item.id}
      onClick={handleClick}
    >
      <CheckboxElement
        isHidden={useMetricTypes}
        isChecked={item.selected}
        isDisabled={isDisabled}
        className="metrics-checkbox"
      />
      <ListItemText>{item.label}</ListItemText>
      <ExpandIcon
        isOpen={isSectionOpen}
        isHidden={!useMetricTypes}
      />
    </ListItemButton>
    {useMetricTypes && isSectionOpen && <List className="searchable-list" disablePadding>
      {map(metricTypeOptions, option => <MetricType
        key={`${item.id}.${option.id}`}
        option={option}
        toggleSelectedMetricColumn={toggleSelectedMetricColumn}
        disableOptions={disableOptions}
        subcategoryType={subcategoryType}
        itemId={item.id}
      />)}
    </List>}
  </Fragment>
}

Metric.propTypes = {
  subcategoryType: PropTypes.string.isRequired,
  item: MetricItemShape.isRequired,
  toggleSection: PropTypes.func.isRequired,
  toggleSelectedMetricColumn: PropTypes.func.isRequired,
  disableOptions: PropTypes.bool.isRequired,
  includeMetricTypes: PropTypes.bool,
  getIsSectionOpen: PropTypes.func.isRequired,
}
